export enum ANNOUNCE_STATUS {
  DRAFT = "draft",
  SEARCH = "search",
  STAFFED = "staffed",
}
